import React, { useMemo } from 'react'
import injectSheet from 'react-jss'
import styles from './slide.styles'
import Slide from '../../../components/slide/slide.jsx'
import Heading from '../../../components/heading/heading.jsx'
import SlideText from '../../../components/slide-text/slide-text.jsx'
import ScrollFade from '../../../components/scroll-fade/scroll-fade.jsx'
import { withPresentation } from '../../../presentation-connectors'
import { backgroundColors } from '../../../colors'

const TextSlide = ({ classes, slides, id }) => {
  const data = slides[id]

  const slideData = useMemo(() => {
    const color = backgroundColors[data.secondaryColor] || backgroundColors.none
    return {
      text: data.body,
      html: data.html_body,
      title: data.title,
      bgColor: color.color,
      bgTextcolor: color.contrasting
    }
  }, [data])

  return (
    <Slide className={classes.container}>
      <Heading className={classes.head}>{slideData.title}</Heading>
      <div className={classes.bodyHolder}>
        <SlideText
          contrast={slideData.bgColor !== '#FAFAFA'}
          html={slideData.html}
          className={classes.body}
          style={{
            backgroundColor: slideData.bgColor,
            color: slideData.bgTextcolor
          }}
        />
        <ScrollFade color={slideData.bgColor} />
      </div>
    </Slide>
  )
}

export default withPresentation(injectSheet(styles)(TextSlide))
